import MainSeo from '@components/MainSeo/MainSeo';
import { ISeo } from '@typescript/index';
import { TCmsBlocks } from '@features/cms/typescript';
import CategoryBlocks from '@features/cms/components/pages/CategoryBlocks/CategoryBlocks';
type PropsType = {
  content?: Record<string, TCmsBlocks>;
  seo: ISeo;
};
const CollectionPage = ({
  content = undefined,
  seo
}: PropsType) => {
  const pageBlocks: TCmsBlocks[] = [];
  if (content) {
    const keys = Object.keys(content);
    keys.forEach(key => {
      if (content[key].type !== 'visualBlock') {
        pageBlocks.push(content[key]);
      }
    });
  }
  return <>
      {seo && <MainSeo seo={seo} />}
      <CategoryBlocks pageBlocks={pageBlocks} />
    </>;
};
export default CollectionPage;